/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_StateDto } from '../models/PagedResultDto_StateDto';
import type { Wealthlane_CustomerService_Dtos_State_CreateUpdateStateDto } from '../models/Wealthlane_CustomerService_Dtos_State_CreateUpdateStateDto';
import type { Wealthlane_CustomerService_Dtos_State_StateDto } from '../models/Wealthlane_CustomerService_Dtos_State_StateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StateService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_State_StateDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppStateStates(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_State_StateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/state/states',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param countryId 
     * @returns Wealthlane_CustomerService_Dtos_State_StateDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppStateByCountry(
countryId: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_State_StateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/state/by-country/{countryId}',
            path: {
                'countryId': countryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_State_StateDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppState(
requestBody?: Wealthlane_CustomerService_Dtos_State_CreateUpdateStateDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_State_StateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/state',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_StateDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppState(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_StateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/state',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_State_StateDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppState(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_State_CreateUpdateStateDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_State_StateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/state/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppState(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/state/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_State_StateDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppState1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_State_StateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/state/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
